const GTM_ID = 'GTM-W6WDG5X';
const GA_ID = 'G-JK2PKY076Q';

export const GoogleAnalytics = {
    initialize() {
        if (GoogleAnalytics.element) {
            return console.warn('Analytics already initialized');
        }
        GoogleAnalytics.element = true;

        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };
        window.dataLayer.push({language: localStorage.getItem('language') || 'ka'});

        const gtm = document.createElement('script');
        window.dataLayer.push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        gtm.async = true;
        gtm.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
        document.head.appendChild(gtm);

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(script);

        window.gtag('js', new Date());
        window.gtag('config', GA_ID, {anonymize_ip: true, groups: 'ga'});
    },
};
